import FullWidthLayout from "@/layouts/FullWidthLayout";
import { KPageIndex } from "kinnect-general";
import { Pageable } from "kinnect-mixins";

export default {
	name: "CounterSalesPage",

	metaInfo: { title: "Counter Sales" },

	mixins: [ Pageable ],

	data: () => ( {
		items: [
			{
				title: "Sales Leads",
				to: { name: "salesLeads" }
			},
			{
				title: "Spec Sheets",
				to: { name: "specSheets" }
			}
		]
	} ),

	render() {
		return <FullWidthLayout>
			<KPageIndex items={this.items}></KPageIndex>
		</FullWidthLayout>;
	}
};
